export const VSCODE_BASE_URL = 'vscode://vscode.git/clone?url=';
export const JETBRAINS_BASE_URL =
  'jetbrains://idea/checkout/git?idea.required.plugins.id=Git4Idea&checkout.repo=';
